import { useLocation } from 'react-router-dom';
import { useShipForm } from '../../../context/shipForms';
import { Tooltip } from 'react-tooltip';

interface Props {
  key: any;
  updateBCTypeForm: any;
  line?: any;
  index: any;
  isAllIn: boolean;
  setIsAllIn: any;
  isHandling: boolean;
  setIsHandling: any;
}
function PlanningLinesRows({
  updateBCTypeForm,
  line,
  index,
  isAllIn,
  setIsAllIn,
  isHandling,
  setIsHandling,
}: Props) {
  const {
    getSelectedRateContext,
    getSelectedManualLegsContext,
    getSelectedATALegsInfo,
  } = useShipForm();
  const location = useLocation();
  const isAddLegs = location?.pathname === '/app/add-leg';
  const selectedRateContext = getSelectedRateContext();
  const selectedManualLegContextContext = getSelectedManualLegsContext();
  const selectedLegInfoContext = getSelectedATALegsInfo();
  const defaultLegRecord =
    selectedLegInfoContext &&
    selectedLegInfoContext.find((item: any) => item.leg === line?.leg);
  let cost = '';
  let title = '';
  let carrierName = '';
  let serviceName = '';

  const getRates = (selectedRateContext: any) => {
    return {
      pickupRate: selectedRateContext?.pickup?.rate?.total,
      mainRate: selectedRateContext?.main?.rate?.total,
      deliveryRate: selectedRateContext?.delivery?.rate?.total,
    };
  };

  switch (line.leg) {
    case 'A1':
      cost = selectedRateContext?.main?.rate?.total;
      carrierName = selectedRateContext?.main?.routing[0]?.carrier_name;
      serviceName = selectedRateContext?.main.routing[0]?.service_name;
      title = 'Main Leg';
      break;
    case 'A2':
      cost = selectedRateContext?.main?.rate?.total;
      carrierName = selectedRateContext?.main?.routing[1]?.carrier_name;
      serviceName = selectedRateContext?.main.routing[1]?.service_name;
      title = 'Main Leg';
      break;
    case 'P':
      cost = selectedRateContext?.pickup?.rate?.total;
      carrierName = selectedRateContext?.pickup?.routing[0]?.carrier_name;
      serviceName = selectedRateContext?.pickup?.routing[0]?.service_name;
      title = 'Pickup Leg';
      break;
    case 'D':
      cost = selectedRateContext?.delivery?.rate?.total;
      carrierName = selectedRateContext?.delivery?.routing[0]?.carrier_name;
      serviceName = selectedRateContext?.delivery?.routing[0]?.service_name;
      title = 'Delivery Leg';
      break;
    case 'T':
      cost = selectedRateContext?.transfer?.rate?.total;
      carrierName = selectedRateContext?.transfer?.routing[0]?.carrier_name;
      serviceName = selectedRateContext?.transfer?.routing[0]?.service_name;
      title = 'Delivery Leg';
      break;
    case 'Handling':
      break;
    case 'Allin':
      break;
    default:
      cost = selectedManualLegContextContext
        ? selectedManualLegContextContext[index]?.cost
        : selectedLegInfoContext
          ? defaultLegRecord?.ratesInfo?.total
          : '';
      carrierName = selectedManualLegContextContext
        ? selectedManualLegContextContext[index]?.carrier_name
        : selectedLegInfoContext
          ? defaultLegRecord?.routing?.carrier_name
          : '';
      serviceName = selectedManualLegContextContext
        ? selectedManualLegContextContext[index]?.service_name
        : selectedLegInfoContext
          ? defaultLegRecord?.routing?.service_name
          : '';
      title = line.leg;
      break;
  }

  const calculateCost = (line: any, selectedRateContext: any) => {
    const { pickupRate, mainRate, deliveryRate } =
      getRates(selectedRateContext);
    // Handle 'Handling' or 'A2'
    if (line?.leg === 'Handling' || line?.leg === 'A2') {
      return '-';
    }

    // Handle 'Allin'
    if (line?.leg === 'Allin') {
      return '0.00';
    }

    if (!pickupRate && line?.leg === 'L1') {
      return mainRate;
    }

    if (!pickupRate && line?.leg === 'L2') {
      return deliveryRate;
    }

    // Handle specific legs
    if (line?.leg === 'L1') {
      return pickupRate;
    }

    if (line?.leg === 'L2') {
      return mainRate;
    }

    if (line?.leg === 'L3') {
      return deliveryRate;
    }

    return '-';
  };

  const calculateTotalCost = (line: any, selectedRateContext: any) => {
    const { pickupRate, mainRate, deliveryRate } =
      getRates(selectedRateContext);
    const markup: any = line?.markup / 100 + 1;

    // Check for 'Handling' or 'A2'
    if (line?.leg === 'Handling' || line.leg === 'A2') {
      return '-';
    }

    // Check for 'Allin'
    if (line?.leg === 'Allin') {
      return '0.00';
    }

    if (!pickupRate && line?.leg === 'L1') {
      if (line?.markup === '') {
        return mainRate;
      } else if (parseFloat(mainRate) * parseFloat(line?.markup) <= 0) {
        return mainRate;
      } else {
        return (parseFloat(mainRate) * markup).toFixed(3);
      }
    }

    if (!pickupRate && line?.leg === 'L2') {
      if (line?.markup === '') {
        return deliveryRate;
      } else if (parseFloat(deliveryRate) * parseFloat(line?.markup) <= 0) {
        return deliveryRate;
      } else {
        return (parseFloat(deliveryRate) * parseFloat(markup)).toFixed(3);
      }
    }

    // Handle specific legs
    if (line?.leg === 'L1') {
      if (line?.markup === '') {
        return pickupRate;
      } else if (parseFloat(pickupRate) * parseFloat(line?.markup) <= 0) {
        return pickupRate;
      } else {
        return (parseFloat(pickupRate) * parseFloat(markup)).toFixed(3);
      }
    }

    if (line?.leg === 'L2') {
      if (line?.markup === '') {
        return mainRate;
      } else if (parseFloat(mainRate) * parseFloat(line?.markup) <= 0) {
        return mainRate;
      } else {
        return (parseFloat(mainRate) * parseFloat(markup)).toFixed(3);
      }
    }

    if (line?.leg === 'L3') {
      if (line?.markup === '') {
        return deliveryRate;
      } else if (parseFloat(deliveryRate) * parseFloat(line?.markup) <= 0) {
        return deliveryRate;
      } else {
        return (parseFloat(deliveryRate) * parseFloat(markup)).toFixed(3);
      }
    }

    return '-';
  };

  return (
    <tr id='bc_main_row'>
      {line?.leg === 'Handling' ? (
        <td className='align-middle'>
          <div className='d-flex align-items-center form-check'>
            <input
              className='form-check-input'
              type='checkbox'
              id='bc_is_handling'
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              checked={isHandling}
              data-tooltip-id='handling-info'
              data-tooltip-content={
                'Add Handling cost to \nshipment, uncheck to not \nadd.'
              }
              style={{ float: 'unset' }}
              onChange={(e) => {
                setIsHandling(e.target.checked);
              }}
            />
            <label
              className='lex-18-400 ps-1 mt-1'
              htmlFor='bc_is_handling'
            >
              Handling
            </label>
            <Tooltip
              id='handling-info'
              className='tooltip-styles'
            />
          </div>
        </td>
      ) : line?.leg === 'Allin' ? (
        <td className='align-middle'>
          <div className='d-flex align-items-center form-check '>
            <input
              className='form-check-input'
              type='checkbox'
              id='bc_is_all'
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              data-tooltip-id='allin-info'
              data-tooltip-content={'If checked, all legs must be\n budget.'}
              style={{ float: 'unset' }}
              checked={isAllIn}
              onChange={(e) => {
                setIsAllIn(e.target.checked);
              }}
            />
            <label
              className='form-check-label lex-18-400 ps-1  mt-1'
              htmlFor='bc_is_all'
            >
              All in
            </label>
            <Tooltip
              id='allin-info'
              className='tooltip-styles'
            />
          </div>
        </td>
      ) : (
        <td className='align-middle'>
          <label className='lex-18-400'>
            {isAddLegs ? title : `L${index + 1}`}
          </label>
          <br />
          <label
            id='bc_main_carrier'
            className='fw-normal small'
          >
            {carrierName}
          </label>
          <br />
          <label
            id='bc_main_service'
            className='fw-normal small'
          >
            {serviceName}
          </label>
          <br />
        </td>
      )}
      <td className='align-middle'>
        <select
          className='form-select ubbe-input w-100 ubbe-dark-border'
          data-width='100%'
          data-live-search='true'
          id='bc_line_type_main'
          data-size='8'
          value={line?.line_type}
          style={{ textOverflow: 'ellipsis', paddingRight: '30px' }}
          onChange={(e) => {
            updateBCTypeForm({
              ...line,
              line_type: e.target.value,
            });
          }}
        >
          {line?.leg === 'Handling' || line?.leg === 'Allin' ? (
            <>
              <option value='2'>Billable</option>
            </>
          ) : (
            <>
              <option value='3'>Both Budget and Billable</option>
              <option value='1'>Budget</option>
            </>
          )}
        </select>
      </td>
      <td className='align-middle'>
        <select
          className='form-select ubbe-input w-100 ubbe-dark-border'
          data-live-search='true'
          id='bc_items_main'
          data-size='8'
          data-loaded='false'
          value={line?.item}
          onChange={(e) => {
            updateBCTypeForm({
              ...line,
              item: e.target.value,
            });
          }}
          style={{ textOverflow: 'ellipsis', paddingRight: '30px' }}
        >
          {line?.leg === 'Handling' ? (
            <>
              <option value='FF_SHIP_HANDLING'>
                Freight Forwarding Shipment Handling
              </option>
              <option value='FF_SHIP_HANDLING_AH'>
                Freight Forwarding Shipment Handling - After Hours
              </option>
              <option value='SC_SHIP_HAND_FLAT'>
                Supply Chain Shipment Handling - Flat
              </option>
            </>
          ) : (
            <>
              <option value='TRANSPORTATION'>
                Third Party Transportation Service
              </option>
              <option value='TRANS_AIR'>Third Party Air Transportation</option>
              <option value='TRANS_COURIER'>
                Third Party Courier Transportation
              </option>
              <option value='TRANS_FTL'>Third Party FTL Transportation</option>
              <option value='TRANS_LTL'>Third Party LTL Transportation</option>
              <option value='TRANS_OCEAN'>
                Third Party Ocean Transportation
              </option>
              <option value='FLOW_THRU'>Transportation Flow Thru</option>
              <option value='FLOWTHRU_AIR'>
                Air Transportation Flow Thru tax
              </option>
              <option value='FLOWTHRU_COURIER'>Courier Flow Thru tax</option>
              <option value='FLOWTHRU_FTL'>
                FTL Transportation Flow Thru tax
              </option>
              <option value='FLOWTHRU_LTL'>
                LTL Transportation Flow Thru tax
              </option>
              <option value='FLOWTHRU_OCEAN'>
                Ocean Transportation Flow Thru tax
              </option>
            </>
          )}
        </select>
      </td>
      <td className='align-middle'>
        <select
          className='form-select ubbe-input w-100 ubbe-dark-border'
          data-live-search='true'
          id='bc_branch_main'
          data-size='8'
          value={line?.branch_code}
          style={{ paddingRight: '30px' }}
          onChange={(e) => {
            updateBCTypeForm({
              ...line,
              branch_code: e.target.value,
            });
          }}
        >
          <option value='110'>110</option>
          <option value='125'>125</option>
          <option value='127'>127</option>
          <option value='129'>129</option>
          <option value='130'>130</option>
          <option value='131'>131</option>
          <option value='195'>195</option>
        </select>
      </td>
      <td className='align-middle'>
        <select
          className='form-select ubbe-input w-100 ubbe-dark-border'
          data-live-search='true'
          id='bc_cost_main'
          data-size='8'
          value={line?.cost_centre}
          style={{ paddingRight: '30px' }}
          onChange={(e) => {
            updateBCTypeForm({
              ...line,
              cost_centre: e.target.value,
            });
          }}
        >
          <option value='210'>210</option>
          <option value='211'>211</option>
          <option value='213'>213</option>
          <option value='224'>224</option>
          <option value='230'>230</option>
        </select>
      </td>
      <td className='align-middle'>
        <select
          className='form-select ubbe-input w-100 ubbe-dark-border'
          data-live-search='true'
          id='bc_location_main'
          data-size='8'
          value={line?.location_code}
          style={{ textOverflow: 'ellipsis', paddingRight: '30px' }}
          onChange={(e) => {
            updateBCTypeForm({
              ...line,
              location_code: e.target.value,
            });
          }}
        >
          <option value='YEG'>YEG</option>
          <option value='YEGFF'>YEGFF</option>
          <option value='YEGFFAPP'>YEGFFAPP</option>
          <option value='ISUYEG'>ISUYEG</option>
          <option value='YEV'>YEV</option>
        </select>
      </td>
      <td
        className='text-center align-middle'
        id='bc_main_price'
      >
        {calculateCost(line, selectedRateContext)}
      </td>
      <td className='align-middle'>
        {line?.leg === 'Handling' || line.leg === 'A2' ? (
          '-'
        ) : (
          <>
            <input
              type={'number'}
              className='form-control ubbe-input ubbe-dark-border'
              id='bc_markup_main'
              autoComplete='new-password'
              placeholder='10'
              data-toggle='mai-mark-tooltip'
              data-tooltip-id='optional-info'
              data-tooltip-content={
                'Optional: Default Pricing if empty, otherwise overrides BC.'
              }
              value={line?.markup}
              onChange={(e) => {
                updateBCTypeForm({
                  ...line,
                  markup: e.target.value,
                });
              }}
            />
            <Tooltip
              id='optional-info'
              className='tooltip-styles'
            />
          </>
        )}
      </td>
      <td
        className='text-center align-middle'
        id='bc_main_result'
      >
        {calculateTotalCost(line, selectedRateContext)}
      </td>
    </tr>
  );
}

export default PlanningLinesRows;
